import React from "react";
import "../css/Loader.css"; // Import CSS for styling

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
      {/* <div className="loader-text">Loading...</div> */}
    </div>
  );
};

export default Loader;
